export default {
  tabList: {
    all: "All",
    identity_providers: "Identity provider",
    communication: "Communication",
    security: "Security",
    directory_management: "Directory Management",
    compliance: "Compliance",
  },
  tabList_all: "All",
  tabList_sso: "SSO",
  tabList_compliance: "Compliance",
  tabList_accessibility: "Accessibility",
  searchInIntegrations: "Search",
  integration_empty_state_title: "No integration found",
  integration_empty_state_description:
    "The Integrations section allows you to connect Trio with third-party platforms such as Identity Providers, communication tools, Directory management systems, and security tools, enhancing workflows and centralizing control.",
  integration_with: "Integration with {{serviceName}}",
  integration_connect_description:
    "Link your {{service}} account to forward Trio notifications to your {{service}} channels.",
  integration_connect_select_service: "Connect to your preferred service",
  integration_oidc_connect_description:
    "With a secure authentication protocol, OIDC makes user identity verification simple and fast.",
  integration_saml_connect_description:
    "Embrace the power of SAML protocol for secure and efficient authentication.",
  integration_saml_connect_first_step_description_clue1:
    "Go to your {{serviceName}} Account and use this",
  integration_saml_connect_first_step_description_clue2: "authorized URLs",
  saml_connect_first_step_form_name_id: "Name ID",
  saml_connect_first_step_form_acs_url: "ACS URL",
  saml_connect_first_step_form_audience_url: "Audience URL (Optional)",
  integration_saml_connect_second_step_description_clue1: "Enter the ",
  integration_saml_connect_second_step_description_clue2: "authorized URLs ",
  integration_saml_connect_second_step_description_clue3:
    "in the fields provided below ",
  integration_saml_connect_form_loginUrl: "Login URL",
  integration_saml_connect_form_audience: "Issuer URL",
  integration_saml_connect_form_logoutUrl: "Logout URL",
  integration_saml_connect_form_idpCert: "Please upload your x509 certificate.",
  integration_saml_connect_form_toast_title:
    "{{serviceName}} connected successfully!",
  integration_oidc_connect_first_step_description_clue1:
    "Please go to your account and use this ",
  integration_oidc_connect_first_step_description_clue2:
    " authorized redirect URL",
  integration_saml_connect_form_toast_description:
    "Manage user identities with ease through {{serviceName}}.",
  integration_drawer_confirm_title: "Close Integration?",
  integration_drawer_confirm_decription:
    "Are you sure? By closing, all the data that you entered will be lost.",
  integration_disconnect_confirm_title:
    "Disconnect {{seriveName}} {{protocol}} protocol?",
  integration_disconnect_confirm_decription:
    "Are you sure? Once disconnected, Trio & {{seriveName}} won’t sync anymore.",
  integration_saml_disconnect_toast_title:
    "{{serviceName}} disconnected successfully!",
  integration_saml_disconnect_alert_toast_title:
    "{{serviceName}} alert disconnected successfully!",
  integration_saml_disconnect_toast_description:
    "Trio & {{serviceName}} are no longer synchronized",
  integration_saml_disconnect_alert_toast_description:
    "Trio & {{serviceName}} alert are no longer synchronized",
  integration_oidc_connect_form_secret: "Secret",
  integration_oidc_connect_form_domain: "Domain URL",
  integration_oidc_connect_form_clientId: "Client Id",
  domains: {
    GSUIT: "Google Account",
    MICROSOFT_ENTRA_ID: "Office 365",
  },
  You_Are_Allowed_To_Connect_Only_One_SSO_Integration:
    "You are allowed to connect only one SSO integration",
  alert_send: "Alert send successfully",
  alert_save: "Alert save successfully",
  set_event_alert: "Set Event Alert",
  alert_detail: "Alert details",
  alert_name: "Event Alert name",
  select_channel: "Select channel",
  test_alert: "Test alert",
  test_alert_des:
    "Send a test notification before adding the Event Alert. We will provide a sample message to the specified channel(s) above.",
  send_test_alert: "Send test alert",
  loading: "Loading...",
  alertDescription: `You can see the event alert that you want to send throughout this
  integration`,
  alerts: "Alerts",

  ///new
  addAndConfig: "Add & Configure",
  scimDescription:
    "The System for Cross-Domain Identity Management (SCIM) specification simplifies user identity management in cloud-based applications applications and services.",
  scimButtonText: "Click to configure SCIM",
  configuring: "Configuring",
};
